import React from "react";

import VideoContainer from "./VideoContainer";

const MainContainer = () => {
  return (
    <div className="col-span-10 mt-14">
      <VideoContainer />
    </div>
  );
};

export default MainContainer;
